export default {"src":"/_next/static/media/staysure-logo-white.1d1c7805.svg","height":40,"width":159,"blurWidth":0,"blurHeight":0};